import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import configs from "../../configs/config";

import {
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Alert,
  Divider,
  Box,
} from "@mui/material";
import { getSubDomainName } from "../helpers/helperFunctions";
import { getTenantBySubDomain } from "../../redux/actions/Login/Login";

const WebformValuesSSO = () => {
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [formValues, setFormValues] = useState<any>(null);

  const ticketId = searchParams.get("ticketId");
  const ticketLogId = searchParams.get("ticketLogId");

  useEffect(() => {
    if (!ticketId || !ticketLogId) {
      setError("Invalid URL: ticketId or ticketLogId missing.");
      setLoading(false);
      return;
    }

    const fetchWebformValues = async () => {
      try {
        const subDomain = getSubDomainName();
        const tenantRes = await axios(`${getTenantBySubDomain}${subDomain}`);
               
        const url = `${configs.BASE_URL}/ssp/api/user/WebformValues`;
        const response = await axios.get(url, {
          params: {
            ticketId,
            ticketLogId,
          },
           headers: {
          "tenant-code": tenantRes.data.tenantcode,
        },
        });

        const data = response?.data
        
       

        let parsedValues = {};
        if (data?.webformValuesJson) {
          parsedValues = JSON.parse(data?.webformValuesJson);
        }

        setFormValues({
          ...data,
          webformValuesJson: parsedValues,
        });
      } catch (err: any) {
        setError(err?.response?.data?.message || err?.message);
      } finally {
        setLoading(false);
      }
    };

    fetchWebformValues();
  }, [ticketId, ticketLogId]);

  if (loading)
    return (
      <Box display="flex" justifyContent="center" mt={10}>
        <CircularProgress size={50} />
      </Box>
    );

  if (error)
    return (
      <Box m={3}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );

  return (
    <Box sx={{ maxWidth: 800, margin: "40px auto",  }}>
      <Card elevation={4} sx={{ borderRadius: 3 }}>
        <CardContent>
          <Typography variant="h5" fontWeight={600} gutterBottom>
            Webform Details
          </Typography>

          <Divider sx={{ mb: 2 }} />

          <Box display="flex" flexDirection="column" rowGap={1}>
            <Typography><strong>Ticket ID:</strong> {formValues?.ticketId}</Typography>
            <Typography><strong>TicketLog ID:</strong> {formValues?.ticketLogsId}</Typography>
            <Typography><strong>Webform ID:</strong> {formValues?.webformId}</Typography>
          </Box>

          <Box
            sx={{
              p: 2,
              borderRadius: 2,
            }}
          >
            {Object.entries(formValues?.webformValuesJson ||{})?.map(
              ([key, value]: any) => (
                <Box
                  key={key}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #eee",
                    py: 1,
                  }}
                >
                  <Typography fontWeight={600} sx={{ color: "#444" }}>
                    {key}
                  </Typography>

                  <Typography sx={{ ml: 2, color: "#555" }}>
                    {String(value)}
                  </Typography>
                </Box>
              )
            )}
          </Box>

        </CardContent>
      </Card>
    </Box>
  );
};

export default WebformValuesSSO;
